import { APICore } from "../apiCore";

const api = new APICore();

function listGenres(guild) {
    return api.get(`/genre/guild/${ guild }`, {});
}

export { listGenres };
